import React, { useState,useEffect } from "react";
import { Close } from "assets/svg/sidebar/icons";

export default function AlertBar({content,onClose, onCloseText,showBtnExit = false}) { 
  const [state] = useState({
    loading: false,
    verificationSent: false,
  });

  return (
    <div className="alerts"> 
          <div className="w-full alert" >
            <div className="flex justify-center w-full">
                {content()}
            </div>
            <button
              onClick={onClose}
              disabled={state.loading}
              className="items-center justify-center flex close-alert"
            > 
               { (onCloseText || showBtnExit) && <span className="flex gap-2 items-center"><Close className="w-4 h-4 " fill={"white"} /> <span className="hidden md:block">{onCloseText}</span></span>} 
            </button>
          </div> 
    </div>
  );
}
